import React, { type FC } from "react";
import styles from "./Summary.module.scss";
import useAphModal from "../../../../hooks/useAphModal";
import { CarConfigLabel, useCarConfigOptionalLabel } from "../../../../utils/labelUtils";
import Button from "../../../../../shared-components/css-modules/lexus/atoms/Button";
import { MODAL_CONTENT } from "../../../../../../../common-deprecated/utils/modalConstants";
import Icon from "../../../../../shared-components/css-modules/lexus/atoms/Icon";

const SummaryManufacturerInfo: FC = () => {
    const { showModalHelper } = useAphModal();
    const manufacturerTitle = useCarConfigOptionalLabel("carConfigOverviewManufacturerInfoTitle");
    const manufacturerInfoContent = useCarConfigOptionalLabel("carConfigOverviewManufacturerInfoContent");

    const manufacturerContactTitle = useCarConfigOptionalLabel("carConfigOverviewManufacturerContactTitle");
    const manufacturerContactContent = useCarConfigOptionalLabel("carConfigOverviewManufacturerContactContent");

    if (!manufacturerInfoContent || !manufacturerTitle || !manufacturerContactTitle || !manufacturerContactContent)
        return null;

    const manufacturerContent = `
    ${manufacturerInfoContent}<br><br>
    <h3>${manufacturerContactTitle}</h3><br>
    ${manufacturerContactContent}
    `;
    return (
        <Button
            onClick={() => showModalHelper(MODAL_CONTENT, { title: manufacturerTitle, content: manufacturerContent })}
            className={styles["manufacturer-Info"]}
            variant="btn-icon-text"
        >
            <Icon variant="pencil-with-paper" sizing="sm" />
            <CarConfigLabel label="carConfigOverviewManufacturerInfoTitle" />
        </Button>
    );
};

export default SummaryManufacturerInfo;
